import { Link, useHistory, useParams } from "react-router-dom"
import { Group, Title, Button, Divider, Text, Stack, Anchor, Menu } from "@mantine/core"
import { ProgramRegistrationListByProgramGroup, RecentProgramRegistrationList } from "../../Components/ProgramRegistrations/ProgramRegistrationList"
import { useProgramGroupsQuery } from "../../api/program.api";
import { linkTitle } from "../../shared/helpers";
import { IconChevronDown, IconChevronRight, IconPlus } from "@tabler/icons-react";
import { RoleTemplate } from "../../Components/RoleTemplate";
import { useFamilyRegistrationState } from "../../state/familyregistration.state";
import { useProgramRegistrationState } from "../../state/programregistration.state";
import { createEmptyProgramRegistration } from "../../functions/programregistration.functions";

export interface RegistationPageParams {
	urlProgramGroup: string;
}

const RegistationsHomePage = () => {
	const history = useHistory();
	const { urlProgramGroup } = useParams<RegistationPageParams>();
	const { data: programGroups } = useProgramGroupsQuery();
	const { setProgramRegistration } = useProgramRegistrationState();
	const { reset } = useFamilyRegistrationState();

	const programGroup = programGroups?.find(g => linkTitle(g.Title) === urlProgramGroup);

	const handleNewRegistration = () => {
		let newRegistration = createEmptyProgramRegistration();
		setProgramRegistration(newRegistration);
		
		history.push({ pathname: `/registrations/new` });
	}

	const handleNewFamilyRegistration = () => {
		reset();
		history.push({ pathname: `/registrations/family/new` });
	}

	return <>
		<Group justify="space-between" mb="md" align="start">
			<Stack gap={0}>
				<Group gap={5}>
					<Anchor component={Link} to="/" fz="sm" fw="bold">Home</Anchor>
					<IconChevronRight size="14" />
				</Group>
				{programGroup &&
				<Title order={1} mb="sm">Registrations for {programGroup?.Title}</Title>
				}
				{!programGroup &&
				<Title order={1} mb="sm">All Registrations</Title>
				}
			</Stack>
			{/* <RoleTemplate role="role.admin">
				<Button component={Link} to="/registrations/new" size="sm" variant="subtle" sx={{ alignSelf: 'flex-start'}} mb="sm" leftIcon={<IconPlus />}>New Registration</Button>
			</RoleTemplate> */}

			<Group gap="xs" mb="xs" wrap="nowrap">
				<RoleTemplate role="role.user.readwrite">
					{/* <Divider orientation="vertical" ml="md" mr={1} /> */}
					<Menu position="bottom-end" shadow="md">
						<Menu.Target>
							<Button variant="filled" size="sm" rightSection={<IconChevronDown />}>Create</Button>
						</Menu.Target>

						<Menu.Dropdown>
							<Menu.Item onClick={handleNewRegistration} leftSection={<IconPlus />}>New Registration</Menu.Item>
							<Menu.Item onClick={handleNewFamilyRegistration} leftSection={<IconPlus />}>New Family Registration</Menu.Item>							
						</Menu.Dropdown>
					</Menu>
				</RoleTemplate>
			</Group>
		</Group>
		{/* <Divider /> */}

		{programGroup &&
		<ProgramRegistrationListByProgramGroup programGroupId={programGroup.Id} />
		}
		{!programGroup &&
		<RecentProgramRegistrationList />
		}
	</>
}

export default RegistationsHomePage